import { render, staticRenderFns } from "./ModalForceUpdate.vue?vue&type=template&id=0c1d440a&scoped=true&"
import script from "./ModalForceUpdate.vue?vue&type=script&lang=js&"
export * from "./ModalForceUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ModalForceUpdate.vue?vue&type=style&index=0&id=0c1d440a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d440a",
  null
  
)

export default component.exports